import { adminApiFetch } from './apiService';

export const shippingAccountService = {
  fetchList: async () => {
    const response = await adminApiFetch('shipping_accounts');
    return response.json();
  },
  getRecords: async (params) => {
    const response = await adminApiFetch('shipping_accounts/get_records', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },
  getIds: async (params) => {
    const response = await adminApiFetch('shipping_accounts/get_ids', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },

  get: async (id) => {
    const response = await adminApiFetch(`shipping_accounts/${id}`);
    return response.json();
  },

  create: async (data) => {
    const response = await adminApiFetch('shipping_accounts', {
      method: 'POST',
      body: JSON.stringify({ shipping_account: data })
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await adminApiFetch(`shipping_accounts/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ shipping_account: data })
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await adminApiFetch(`shipping_accounts/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  disable: async (id) => {
    const response = await adminApiFetch(`shipping_accounts/${id}/disable`, {
      method: 'PATCH'
    });
    return response.json();
  }
};

export default shippingAccountService;
